import { motion } from "framer-motion";

/**
 * Reveal — scroll-triggered fade + translate reveal wrapper
 */
export default function Reveal({
  children,
  delay = 0,
  y = 32,
  duration = 0.9,
  once = true,
  className = "",
  amount = 0.3,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration, delay, ease: [0.2, 0.8, 0.2, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
